import Vue from "vue";
import Component from "vue-class-component";
import LoaderComponent from "@/components/loader/loader.component.vue";
// Services
import CandidateService from "@/core/services/candidate.service";
import ReportService from "@/core/services/report.service";
import JobService from "@/core/services/job.service";
import { resolveCompanyLogo } from "@/core/constants/fallback-logo";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

@Component({
  components: {
    LoaderComponent,
  },
})
export default class CreateCandidateComponent extends Vue {
  candidateService: any = new CandidateService();
  reportService: any = new ReportService();
  jobService: any = new JobService();
  isLoading: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  surveyName: string = "";
  surveyEndedAt: string = "";

  name: string = "";
  companiesName: string = "";
  surname: string = "";
  companies: string = "";
  jobs: string = "";
  sumEffectiveness: number = 0;
  averageEffectiveness: any = 0;
  sumAdministrative: number = 0;
  averageAdministrative: any = 0;
  sumCommunicative: number = 0;
  averageCommunicative: any = 0;
  sumIntegration: number = 0;
  averageIntegration: any = 0;
  sumCognitive: number = 0;
  averageCognitive: any = 0;
  //
  area1: string = "";
  area2: string = "";
  area3: string = "";
  area4: string = "";
  area5: string = "";
  area6: string = "";
  area7: string = "";
  area8: string = "";
  area9: string = "";
  area10: string = "";
  area11: string = "";
  area12: string = "";
  area13: string = "";
  area14: string = "";

  // Skills
  // E = Excelente
  timeManagementE: boolean = false;
  timeManagementS: boolean = false;
  timeManagementP: boolean = false;
  timeManagementR: boolean = false;
  timeManagementD: boolean = false;
  timeManagementM: boolean = false;
  goalsE: boolean = false;
  goalsS: boolean = false;
  goalsP: boolean = false;
  goalsR: boolean = false;
  goalsD: boolean = false;
  goalsM: boolean = false;
  planE: boolean = false;
  planS: boolean = false;
  planP: boolean = false;
  planR: boolean = false;
  planD: boolean = false;
  planM: boolean = false;
  listenOrganizeE: boolean = false;
  listenOrganizeS: boolean = false;
  listenOrganizeP: boolean = false;
  listenOrganizeR: boolean = false;
  listenOrganizeD: boolean = false;
  listenOrganizeM: boolean = false;
  provideInfoE: boolean = false;
  provideInfoS: boolean = false;
  provideInfoP: boolean = false;
  provideInfoR: boolean = false;
  provideInfoD: boolean = false;
  provideInfoM: boolean = false;
  getInfoE: boolean = false;
  getInfoS: boolean = false;
  getInfoP: boolean = false;
  getInfoR: boolean = false;
  getInfoD: boolean = false;
  getInfoM: boolean = false;
  toTrainE: boolean = false;
  toTrainS: boolean = false;
  toTrainP: boolean = false;
  toTrainR: boolean = false;
  toTrainD: boolean = false;
  toTrainM: boolean = false;
  evaluateE: boolean = false;
  evaluateS: boolean = false;
  evaluateP: boolean = false;
  evaluateR: boolean = false;
  evaluateD: boolean = false;
  evaluateM: boolean = false;
  correctE: boolean = false;
  correctS: boolean = false;
  correctP: boolean = false;
  correctR: boolean = false;
  correctD: boolean = false;
  correctM: boolean = false;
  solveProblemsE: boolean = false;
  solveProblemsS: boolean = false;
  solveProblemsP: boolean = false;
  solveProblemsR: boolean = false;
  solveProblemsD: boolean = false;
  solveProblemsM: boolean = false;
  takeDecisionsE: boolean = false;
  takeDecisionsS: boolean = false;
  takeDecisionsP: boolean = false;
  takeDecisionsR: boolean = false;
  takeDecisionsD: boolean = false;
  takeDecisionsM: boolean = false;
  thinkClearlyE: boolean = false;
  thinkClearlyS: boolean = false;
  thinkClearlyP: boolean = false;
  thinkClearlyR: boolean = false;
  thinkClearlyD: boolean = false;
  thinkClearlyM: boolean = false;
  // Leadership Skills
  x: boolean = false;
  y: boolean = false;
  situational: boolean = false;

  // Single percentage
  skillSingle0: number = 0;
  skillSingle1: number = 0;
  skillSingle2: number = 0;
  skillSingle3: number = 0;
  skillSingle4: number = 0;
  skillSingle5: number = 0;
  skillSingle6: number = 0;
  skillSingle7: number = 0;
  skillSingle8: number = 0;
  skillSingle9: number = 0;
  skillSingle10: number = 0;
  skillSingle11: number = 0;
  skillSingle12: number = 0;
  skillSingle13: number = 0;
  skillSingle14: number = 0;
  // Ideal percentage
  skill0: number = 0;
  skill1: number = 0;
  skill2: number = 0;
  skill3: number = 0;
  skill4: number = 0;
  skill5: number = 0;
  skill6: number = 0;
  skill7: number = 0;
  skill8: number = 0;
  skill9: number = 0;
  skill10: number = 0;
  skill11: number = 0;
  skill12: number = 0;
  skill13: number = 0;
  skill14: number = 0;
  // Estilo
  style1: number = 0;

  //** Comunication Style
  comunicationStyleSkill1: number = 0;
  comunicationStyleSkill2: number = 0;
  comunicationStyleSkill3: number = 0;
  comunicationStyleSkill4: number = 0;
  // Position porcentage Comunication
  barPercentageComunication1: number = 0;
  barPercentageComunication2: number = 0;
  barPercentageComunication3: number = 0;
  barPercentageComunication4: number = 0;
  // Width Comunication
  barWidthPercentageComunication1: number = 0;
  barWidthPercentageComunication2: number = 0;
  barWidthPercentageComunication3: number = 0;
  barWidthPercentageComunication4: number = 0;
  //**//

  //** personal Style
  personalStyleSkill1: number = 0;
  personalStyleSkill2: number = 0;
  personalStyleSkill3: number = 0;
  personalStyleSkill4: number = 0;
  // Position porcentage personal
  barPercentagePersonal1: number = 0;
  barPercentagePersonal2: number = 0;
  barPercentagePersonal3: number = 0;
  barPercentagePersonal4: number = 0;
  // Width Personal
  barWidthPercentagePersonal1: number = 0;
  barWidthPercentagePersonal2: number = 0;
  barWidthPercentagePersonal3: number = 0;
  barWidthPercentagePersonal4: number = 0;
  //**//

  //Brecha
  totalSkillSingle0: number = 0;
  totalSkillSingle1: number = 0;
  totalSkillSingle2: number = 0;
  totalSkillSingle3: number = 0;
  totalSkillSingle4: number = 0;
  totalSkillSingle5: number = 0;
  totalSkillSingle6: number = 0;
  totalSkillSingle7: number = 0;
  totalSkillSingle8: number = 0;
  totalSkillSingle9: number = 0;
  totalSkillSingle10: number = 0;
  totalSkillSingle11: number = 0;
  totalSkillSingle12: number = 0;
  // Styles Sorted Array
  personalSortedArray: any = [];
  communicationSortedArray: any = [];
  // External report variables
  anima_old_onResize: any;
  anima_new_onResize: any;
  defaultMaxBarWidth: number = 300;
  barWidthPercentage1: number = 0;
  barWidthPercentage2: number = 0;
  barWidthPercentage3: number = 0;
  barWidthPercentage4: number = 0;
  barWidthPercentage5: number = 0;
  barWidthPercentage6: number = 0;
  barWidthPercentage7: number = 0;
  barWidthPercentage8: number = 0;
  barWidthPercentage9: number = 0;
  barWidthPercentage10: number = 0;
  barWidthPercentage11: number = 0;
  barWidthPercentage12: number = 0;
  barWidthPercentage13: number = 0;
  barWidthPercentage14: number = 0;
  barWidthPercentageEffectiveness: number = 0;

  // Position number bar
  barPercentage1: number = 0;
  barPercentage2: number = 0;
  barPercentage3: number = 0;
  barPercentage4: number = 0;
  barPercentage5: number = 0;
  barPercentage6: number = 0;
  barPercentage7: number = 0;
  barPercentage8: number = 0;
  barPercentage9: number = 0;
  barPercentage10: number = 0;
  barPercentage11: number = 0;
  barPercentage12: number = 0;
  barPercentage13: number = 0;
  barPercentage14: number = 0;
  barPercentageEffectiveness: number = 0;
  public logo: any = "";
  public logoIsFallback: boolean = false;
  public leftDefault = 211;

  mounted() {
    const _ = this;
    //  External Report
    _.anima_loadAsyncSrc();
    _.anima_old_onResize = window.onresize;
    _.anima_new_onResize = undefined;
    _.anima_updateOnResize();
    setTimeout(function () {
      _.anima_loadAsyncSrc();
    }, 200);
  }

  async created() {
    const _ = this;
    await _.getProfileReport();
    _.getByJob();
  }

  anima_updateOnResize() {
    const _ = this;
    if (
      _.anima_new_onResize == undefined ||
      window.onresize != _.anima_new_onResize
    ) {
      _.anima_new_onResize = function (x) {
        // if (_.anima_old_onResize != undefined) _.anima_old_onResize(x);
        _.anima_loadAsyncSrc();
      };
      window.onresize = _.anima_new_onResize;
      setTimeout(function () {
        _.anima_updateOnResize();
      }, 3000);
    }
  }

  filterDate(date: any = "") {
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  getByJob() {
    const _ = this;
    _.candidateService.getByJob(2).then((data: any) => {
      // return data['data'].jobId.name;
    });
  }

  private async reportToPDF() {
    const pdfDoc = new jsPDF("p", "mm", "a4");
    const htmlPages = document.querySelectorAll(".report-page-to-print"); // Replace '.report-page-to-print' with your actual HTML page selector
    console.log("Printing it?")
    for (let i = 0; i < htmlPages.length; i++) {
      const canvas = await html2canvas(htmlPages[i] as HTMLElement, {
        useCORS: true, // Enable cross-origin images
        scale: 2, // Scale for better quality (2 is optimal for most cases)
        logging: false,
        allowTaint: false,
        backgroundColor: '#ffffff',
        onclone: (document) => {
          // Ensuring fonts are loaded
          document.fonts.ready;
        },
      });

      // jsPDF's PNG path emits invalid image objects for these canvases
      // (pages render white); the JPEG path is the one the comparative
      // report already ships with.
      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const imgWidth = pdfDoc.internal.pageSize.getWidth();
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdfDoc.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);

      if (i < htmlPages.length - 1) {
        pdfDoc.addPage(); // Add a new page for the next image
      }
    }
    console.log("About to download");
    pdfDoc.save(
      `${this.name}-${this.surname}-${this.companiesName}-MAP-Reporte-Individual.pdf`
    ); // Save the final PDF after all pages are processed
  }

  private fillMAPReport(data: any) {
    const _ = this;
    this.surveyName = "MAP";

    for (let j = 0; j < data["data"].report.map.length; j++) {
      if (
        data["data"].report.map[j].name
          .toLowerCase()
          .includes("manejar el tiempo y priorizar")
      ) {
        _.skillSingle1 =
          data["data"].report.map[j].result != undefined
            ? data["data"].report.map[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.map[j].name
          .toLowerCase()
          .includes("establecer metas y objetivos")
      ) {
        _.skillSingle2 =
          data["data"].report.map[j].result != undefined
            ? data["data"].report.map[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.map[j].name
          .toLowerCase()
          .includes("planear y programar el trabajo")
      ) {
        _.skillSingle3 =
          data["data"].report.map[j].result != undefined
            ? data["data"].report.map[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.map[j].name
          .toLowerCase()
          .includes("escuchar y organizar")
      ) {
        _.skillSingle4 =
          data["data"].report.map[j].result != undefined
            ? data["data"].report.map[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.map[j].name
          .toLowerCase()
          .includes("proporcionar información clara")
      ) {
        _.skillSingle5 =
          data["data"].report.map[j].result != undefined
            ? data["data"].report.map[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.map[j].name
          .toLowerCase()
          .includes("obtener información específica")
      ) {
        _.skillSingle6 =
          data["data"].report.map[j].result != undefined
            ? data["data"].report.map[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.map[j].name
          .toLowerCase()
          .includes("entrenar y delegar")
      ) {
        _.skillSingle7 =
          data["data"].report.map[j].result != undefined
            ? data["data"].report.map[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.map[j].name
          .toLowerCase()
          .includes("evaluar el desempeño de la gente")
      ) {
        _.skillSingle8 =
          data["data"].report.map[j].result != undefined
            ? data["data"].report.map[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.map[j].name
          .toLowerCase()
          .includes("corregir y aconsejar")
      ) {
        _.skillSingle9 =
          data["data"].report.map[j].result != undefined
            ? data["data"].report.map[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.map[j].name
          .toLowerCase()
          .includes("identificar y solucionar problemas")
      ) {
        _.skillSingle10 =
          data["data"].report.map[j].result != undefined
            ? data["data"].report.map[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.map[j].name
          .toLowerCase()
          .includes("tomar decisiones y ponderar riesgos")
      ) {
        _.skillSingle11 =
          data["data"].report.map[j].result != undefined
            ? data["data"].report.map[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.map[j].name
          .toLowerCase()
          .includes("pensar clara y juiciosamente")
      ) {
        _.skillSingle12 =
          data["data"].report.map[j].result != undefined
            ? data["data"].report.map[j].result.percentage
            : 0;
      }
      if (data["data"].report.map[j].name.toLowerCase().includes("x")) {
        _.skillSingle13 =
          data["data"].report.map[j].result != undefined
            ? data["data"].report.map[j].result.percentage
            : 0;
      }
      if (data["data"].report.map[j].name.toLowerCase().includes("y")) {
        _.skillSingle14 =
          data["data"].report.map[j].result != undefined
            ? data["data"].report.map[j].result.percentage
            : 0;
      }
    }
  }

  private fillSMAPReport(data: any) {
    const _ = this;
    this.surveyName = "SMAP";
    for (let j = 0; j < data["data"].report.smap.length; j++) {
      if (
        data["data"].report.smap[j].name
          .toLowerCase()
          .includes("manejar el tiempo y priorizar")
      ) {
        _.skillSingle1 =
          data["data"].report.smap[j].result != undefined
            ? data["data"].report.smap[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.smap[j].name
          .toLowerCase()
          .includes("establecer metas y objetivos")
      ) {
        _.skillSingle2 =
          data["data"].report.smap[j].result != undefined
            ? data["data"].report.smap[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.smap[j].name
          .toLowerCase()
          .includes("planear y programar el trabajo")
      ) {
        _.skillSingle3 =
          data["data"].report.smap[j].result != undefined
            ? data["data"].report.smap[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.smap[j].name
          .toLowerCase()
          .includes("escuchar y organizar")
      ) {
        _.skillSingle4 =
          data["data"].report.smap[j].result != undefined
            ? data["data"].report.smap[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.smap[j].name
          .toLowerCase()
          .includes("proporcionar información clara")
      ) {
        _.skillSingle5 =
          data["data"].report.smap[j].result != undefined
            ? data["data"].report.smap[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.smap[j].name
          .toLowerCase()
          .includes("obtener información específica")
      ) {
        _.skillSingle6 =
          data["data"].report.smap[j].result != undefined
            ? data["data"].report.smap[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.smap[j].name
          .toLowerCase()
          .includes("entrenar y delegar")
      ) {
        _.skillSingle7 =
          data["data"].report.smap[j].result != undefined
            ? data["data"].report.smap[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.smap[j].name
          .toLowerCase()
          .includes("evaluar el desempeño de la gente")
      ) {
        _.skillSingle8 =
          data["data"].report.smap[j].result != undefined
            ? data["data"].report.smap[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.smap[j].name
          .toLowerCase()
          .includes("corregir y aconsejar")
      ) {
        _.skillSingle9 =
          data["data"].report.smap[j].result != undefined
            ? data["data"].report.smap[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.smap[j].name
          .toLowerCase()
          .includes("identificar y solucionar problemas")
      ) {
        _.skillSingle10 =
          data["data"].report.smap[j].result != undefined
            ? data["data"].report.smap[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.smap[j].name
          .toLowerCase()
          .includes("tomar decisiones y ponderar riesgos")
      ) {
        _.skillSingle11 =
          data["data"].report.smap[j].result != undefined
            ? data["data"].report.smap[j].result.percentage
            : 0;
      }
      if (
        data["data"].report.smap[j].name
          .toLowerCase()
          .includes("pensar clara y juiciosamente")
      ) {
        _.skillSingle12 =
          data["data"].report.smap[j].result != undefined
            ? data["data"].report.smap[j].result.percentage
            : 0;
      }
      if (data["data"].report.smap[j].name.toLowerCase().includes("x")) {
        _.skillSingle13 =
          data["data"].report.smap[j].result != undefined
            ? data["data"].report.smap[j].result.percentage
            : 0;
      }
      if (data["data"].report.smap[j].name.toLowerCase().includes("y")) {
        _.skillSingle14 =
          data["data"].report.smap[j].result != undefined
            ? data["data"].report.smap[j].result.percentage
            : 0;
      }
    }
  }

  async getProfileReport() {
    const _ = this;
    let userId: any = location.href.split("/");
    userId = userId[4];
    await _.candidateService.getById(userId).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500);
      _.name = data["data"].user.name;
      _.surname = data["data"].user.surname;
      const mainSurvey = data["data"].user.surveys.find((survey: any) => survey.SurveyId === 3 || survey.SurveyId === 4 || survey.SurveyId === 5);
      const endDate = new Date(mainSurvey.endDate);

      _.surveyEndedAt = endDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      _.companiesName = data["data"].user.company.name;
      const rawLogo = data["data"].user.company.logo;
      _.logo = resolveCompanyLogo(rawLogo);
      _.logoIsFallback = _.logo !== rawLogo;
    });

    await _.reportService
      .getProfileReport(userId)
      .then((data: any) => {
        // For to get personal skills
        const isMap = data["data"].report.map;
        const isSmap = data["data"].report.smap;

        if (isMap && isMap.length > 0) {
          _.fillMAPReport(data);
          this.surveyName = "MAP";
        }

        if (isSmap && isSmap.length > 0) {
          _.fillSMAPReport(data);
          this.surveyName = "SMAP";
        }

        if (_.skillSingle13 > _.skillSingle14) {
          _.x = true;
          _.y = false;
        }
        if (_.skillSingle14 > _.skillSingle13) {
          _.y = true;
          _.x = false;
        }

        if (_.skillSingle14 > 70 && _.skillSingle13 > 70) {
          _.x = false;
          _.y = false;
          _.situational = true;
        }
        if (_.skillSingle1 <= 15) {
          _.area1 = "Marginal";
          _.timeManagementM = true;
        }
        if (_.skillSingle1 >= 16 && _.skillSingle1 <= 30) {
          _.area1 = "Deficiente";
          _.timeManagementD = true;
        }
        if (_.skillSingle1 >= 31 && _.skillSingle1 <= 50) {
          _.area1 = "Regular";
          _.timeManagementR = true;
        }
        if (_.skillSingle1 >= 51 && _.skillSingle1 <= 70) {
          _.area1 = "Promedio";
          _.timeManagementP = true;
        }
        if (_.skillSingle1 >= 71 && _.skillSingle1 <= 85) {
          _.area1 = "Superior";
          _.timeManagementS = true;
        }
        if (_.skillSingle1 >= 86) {
          _.area1 = "Excelente";
          _.timeManagementE = true;
        }
        if (_.skillSingle2 <= 15) {
          _.area2 = "Marginal";
          _.goalsM = true;
        }
        if (_.skillSingle2 >= 16 && _.skillSingle2 <= 30) {
          _.area2 = "Deficiente";
          _.goalsD = true;
        }
        if (_.skillSingle2 >= 31 && _.skillSingle2 <= 50) {
          _.area2 = "Regular";
          _.goalsR = true;
        }
        if (_.skillSingle2 >= 51 && _.skillSingle2 <= 70) {
          _.area2 = "Promedio";
          _.goalsP = true;
        }
        if (_.skillSingle2 >= 71 && _.skillSingle2 <= 85) {
          _.area2 = "Superior";
          _.goalsS = true;
        }
        if (_.skillSingle2 >= 86) {
          _.area2 = "Excelente";
          _.goalsE = true;
        }
        if (_.skillSingle3 <= 15) {
          _.area3 = "Marginal";
          _.planM = true;
        }
        if (_.skillSingle3 >= 16 && _.skillSingle3 <= 30) {
          _.area3 = "Deficiente";
          _.planD = true;
        }
        if (_.skillSingle3 >= 31 && _.skillSingle3 <= 50) {
          _.area3 = "Regular";
          _.planR = true;
        }
        if (_.skillSingle3 >= 51 && _.skillSingle3 <= 70) {
          _.area3 = "Promedio";
          _.planP = true;
        }
        if (_.skillSingle3 >= 71 && _.skillSingle3 <= 85) {
          _.area3 = "Superior";
          _.planS = true;
        }
        if (_.skillSingle3 >= 86) {
          _.area3 = "Excelente";
          _.planE = true;
        }
        if (_.skillSingle4 <= 15) {
          _.area4 = "Marginal";
          _.listenOrganizeM = true;
        }
        if (_.skillSingle4 >= 16 && _.skillSingle4 <= 30) {
          _.area4 = "Deficiente";
          _.listenOrganizeD = true;
        }
        if (_.skillSingle4 >= 31 && _.skillSingle4 <= 50) {
          _.area4 = "Regular";
          _.listenOrganizeR = true;
        }
        if (_.skillSingle4 >= 51 && _.skillSingle4 <= 70) {
          _.area4 = "Promedio";
          _.listenOrganizeP = true;
        }
        if (_.skillSingle4 >= 71 && _.skillSingle4 <= 85) {
          _.area4 = "Superior";
          _.listenOrganizeS = true;
        }
        if (_.skillSingle4 >= 86) {
          _.area4 = "Excelente";
          _.listenOrganizeE = true;
        }
        if (_.skillSingle5 <= 15) {
          _.area5 = "Marginal";
          _.provideInfoM = true;
        }
        if (_.skillSingle5 >= 16 && _.skillSingle5 <= 30) {
          _.area5 = "Deficiente";
          _.provideInfoD = true;
        }
        if (_.skillSingle5 >= 31 && _.skillSingle5 <= 50) {
          _.area5 = "Regular";
          _.provideInfoR = true;
        }
        if (_.skillSingle5 >= 51 && _.skillSingle5 <= 70) {
          _.area5 = "Promedio";
          _.provideInfoP = true;
        }
        if (_.skillSingle5 >= 71 && _.skillSingle5 <= 85) {
          _.area5 = "Superior";
          _.provideInfoS = true;
        }
        if (_.skillSingle5 >= 86) {
          _.area5 = "Excelente";
          _.provideInfoE = true;
        }
        if (_.skillSingle6 <= 15) {
          _.area6 = "Marginal";
          _.getInfoM = true;
        }
        if (_.skillSingle6 >= 16 && _.skillSingle6 <= 30) {
          _.area6 = "Deficiente";
          _.getInfoD = true;
        }
        if (_.skillSingle6 >= 31 && _.skillSingle6 <= 50) {
          _.area6 = "Regular";
          _.getInfoR = true;
        }
        if (_.skillSingle6 >= 51 && _.skillSingle6 <= 70) {
          _.area6 = "Promedio";
          _.getInfoP = true;
        }
        if (_.skillSingle6 >= 71 && _.skillSingle6 <= 85) {
          _.area6 = "Superior";
          _.getInfoS = true;
        }
        if (_.skillSingle6 >= 86) {
          _.area6 = "Excelente";
          _.getInfoE = true;
        }
        if (_.skillSingle7 <= 15) {
          _.area7 = "Marginal";
          _.toTrainM = true;
        }
        if (_.skillSingle7 >= 16 && _.skillSingle7 <= 30) {
          _.area7 = "Deficiente";
          _.toTrainD = true;
        }
        if (_.skillSingle7 >= 31 && _.skillSingle7 <= 50) {
          _.area7 = "Regular";
          _.toTrainR = true;
        }
        if (_.skillSingle7 >= 51 && _.skillSingle7 <= 70) {
          _.area7 = "Promedio";
          _.toTrainP = true;
        }
        if (_.skillSingle7 >= 71 && _.skillSingle7 <= 85) {
          _.area7 = "Superior";
          _.toTrainS = true;
        }
        if (_.skillSingle7 >= 86) {
          _.area7 = "Excelente";
          _.toTrainE = true;
        }
        if (_.skillSingle8 <= 15) {
          _.area8 = "Marginal";
          _.evaluateM = true;
        }
        if (_.skillSingle8 >= 16 && _.skillSingle8 <= 30) {
          _.area8 = "Deficiente";
          _.evaluateD = true;
        }
        if (_.skillSingle8 >= 31 && _.skillSingle8 <= 50) {
          _.area8 = "Regular";
          _.evaluateR = true;
        }
        if (_.skillSingle8 >= 51 && _.skillSingle8 <= 70) {
          _.area8 = "Promedio";
          _.evaluateP = true;
        }
        if (_.skillSingle8 >= 71 && _.skillSingle8 <= 85) {
          _.area8 = "Superior";
          _.evaluateS = true;
        }
        if (_.skillSingle8 >= 86) {
          _.area8 = "Excelente";
          _.evaluateE = true;
        }
        if (_.skillSingle9 <= 15) {
          _.area9 = "Marginal";
          _.correctM = true;
        }
        if (_.skillSingle9 >= 16 && _.skillSingle9 <= 30) {
          _.area9 = "Deficiente";
          _.correctD = true;
        }
        if (_.skillSingle9 >= 31 && _.skillSingle9 <= 50) {
          _.area9 = "Regular";
          _.correctR = true;
        }
        if (_.skillSingle9 >= 51 && _.skillSingle9 <= 70) {
          _.area9 = "Promedio";
          _.correctP = true;
        }
        if (_.skillSingle9 >= 71 && _.skillSingle9 <= 85) {
          _.area9 = "Superior";
          _.correctS = true;
        }
        if (_.skillSingle9 >= 86) {
          _.area9 = "Excelente";
          _.correctE = true;
        }
        if (_.skillSingle10 <= 15) {
          _.area10 = "Marginal";
          _.solveProblemsM = true;
        }
        if (_.skillSingle10 >= 16 && _.skillSingle10 <= 30) {
          _.area10 = "Deficiente";
          _.solveProblemsD = true;
        }
        if (_.skillSingle10 >= 31 && _.skillSingle10 <= 50) {
          _.area10 = "Regular";
          _.solveProblemsR = true;
        }
        if (_.skillSingle10 >= 51 && _.skillSingle10 <= 70) {
          _.area10 = "Promedio";
          _.solveProblemsP = true;
        }
        if (_.skillSingle10 >= 71 && _.skillSingle10 <= 85) {
          _.area10 = "Superior";
          _.solveProblemsS = true;
        }
        if (_.skillSingle10 >= 86) {
          _.area10 = "Excelente";
          _.solveProblemsE = true;
        }
        if (_.skillSingle11 <= 15) {
          _.area11 = "Marginal";
          _.takeDecisionsM = true;
        }
        if (_.skillSingle11 >= 16 && _.skillSingle11 <= 30) {
          _.area11 = "Deficiente";
          _.takeDecisionsD = true;
        }
        if (_.skillSingle11 >= 31 && _.skillSingle11 <= 50) {
          _.area11 = "Regular";
          _.takeDecisionsR = true;
        }
        if (_.skillSingle11 >= 51 && _.skillSingle11 <= 70) {
          _.area11 = "Promedio";
          _.takeDecisionsP = true;
        }
        if (_.skillSingle11 >= 71 && _.skillSingle11 <= 85) {
          _.area11 = "Superior";
          _.takeDecisionsS = true;
        }
        if (_.skillSingle11 >= 86) {
          _.area11 = "Excelente";
          _.takeDecisionsE = true;
        }
        if (_.skillSingle12 <= 15) {
          _.area12 = "Marginal";
          _.thinkClearlyM = true;
        }
        if (_.skillSingle12 >= 16 && _.skillSingle12 <= 30) {
          _.area12 = "Deficiente";
          _.thinkClearlyD = true;
        }
        if (_.skillSingle12 >= 31 && _.skillSingle12 <= 50) {
          _.area12 = "Regular";
          _.thinkClearlyR = true;
        }
        if (_.skillSingle12 >= 51 && _.skillSingle12 <= 70) {
          _.area12 = "Promedio";
          _.thinkClearlyP = true;
        }
        if (_.skillSingle12 >= 71 && _.skillSingle12 <= 85) {
          _.area12 = "Superior";
          _.thinkClearlyS = true;
        }
        if (_.skillSingle12 >= 86) {
          _.area12 = "Excelente";
          _.thinkClearlyE = true;
        }
        if (_.skillSingle13 <= 15) {
          _.area13 = "Marginal";
        }
        if (_.skillSingle13 >= 16 && _.skillSingle13 <= 30) {
          _.area13 = "Deficiente";
        }
        if (_.skillSingle13 >= 31 && _.skillSingle13 <= 50) {
          _.area13 = "Regular";
        }
        if (_.skillSingle13 >= 51 && _.skillSingle13 <= 70) {
          _.area13 = "Promedio";
        }
        if (_.skillSingle13 >= 71 && _.skillSingle13 <= 85) {
          _.area13 = "Superior";
        }
        if (_.skillSingle13 >= 86) {
          _.area13 = "Excelente";
        }

        if (_.skillSingle14 <= 15) {
          _.area14 = "Marginal";
        }
        if (_.skillSingle14 >= 16 && _.skillSingle14 <= 30) {
          _.area14 = "Deficiente";
        }
        if (_.skillSingle14 >= 31 && _.skillSingle14 <= 50) {
          _.area14 = "Regular";
        }
        if (_.skillSingle14 >= 51 && _.skillSingle14 <= 70) {
          _.area14 = "Promedio";
        }
        if (_.skillSingle14 >= 71 && _.skillSingle14 <= 85) {
          _.area14 = "Superior";
        }
        if (_.skillSingle14 >= 86) {
          _.area14 = "Excelente";
        }

        //effectiveness profile
        _.sumEffectiveness =
          _.skillSingle1 +
          _.skillSingle2 +
          _.skillSingle3 +
          _.skillSingle4 +
          _.skillSingle5 +
          _.skillSingle6 +
          _.skillSingle7 +
          _.skillSingle8 +
          _.skillSingle9 +
          _.skillSingle10 +
          _.skillSingle11 +
          _.skillSingle12;
        _.averageEffectiveness = (_.sumEffectiveness / 12).toFixed(0);

        //administrative
        _.sumAdministrative = _.skillSingle1 + _.skillSingle2 + _.skillSingle3;
        _.averageAdministrative = (_.sumAdministrative / 3).toFixed(0);

        //communicative
        _.sumCommunicative = _.skillSingle4 + _.skillSingle5 + _.skillSingle6;
        _.averageCommunicative = (_.sumCommunicative / 3).toFixed(0);

        //Integration
        _.sumIntegration = _.skillSingle7 + _.skillSingle8 + _.skillSingle9;
        _.averageIntegration = (_.sumIntegration / 3).toFixed(0);

        //Cognitive
        _.sumCognitive = _.skillSingle10 + _.skillSingle11 + _.skillSingle12;
        _.averageCognitive = (_.sumCognitive / 3).toFixed(0);

        // For to get personal skills
        for (let k = 0; k < data["data"].report.auto.length; k++) {
          if (data["data"].report.auto[k].name.includes("Analítico")) {
            _.barWidthPercentagePersonal1 =
              (data["data"].report.auto[k].score * _.defaultMaxBarWidth) / 100;
            _.barPercentagePersonal1 =
              _.barWidthPercentagePersonal1 + _.leftDefault;
            _.personalStyleSkill1 = data["data"].report.auto[k].score;
          }
          if (data["data"].report.auto[k].name.includes("Creativo")) {
            _.barWidthPercentagePersonal2 =
              (data["data"].report.auto[k].score * _.defaultMaxBarWidth) / 100;
            _.barPercentagePersonal2 =
              _.barWidthPercentagePersonal2 + _.leftDefault;
            _.personalStyleSkill2 = data["data"].report.auto[k].score;
          }
          if (data["data"].report.auto[k].name.includes("Activo")) {
            _.barWidthPercentagePersonal3 =
              (data["data"].report.auto[k].score * _.defaultMaxBarWidth) / 100;
            _.barPercentagePersonal3 =
              _.barWidthPercentagePersonal3 + _.leftDefault;
            _.personalStyleSkill3 = data["data"].report.auto[k].score;
          }
          if (data["data"].report.auto[k].name.includes("Sensible")) {
            _.barWidthPercentagePersonal4 =
              (data["data"].report.auto[k].score * _.defaultMaxBarWidth) / 100;
            _.barPercentagePersonal4 =
              _.barWidthPercentagePersonal4 + _.leftDefault;
            _.personalStyleSkill4 = data["data"].report.auto[k].score;
          }
        }
        // For to get communication skills
        for (let k = 0; k < data["data"].report.communication.length; k++) {
          if (data["data"].report.communication[k].name.includes("Empático")) {
            _.barWidthPercentageComunication1 =
              (data["data"].report.communication[k].score *
                _.defaultMaxBarWidth) /
              100;
            _.barPercentageComunication1 =
              _.barWidthPercentageComunication1 + _.leftDefault;
            _.comunicationStyleSkill1 =
              data["data"].report.communication[k].score;
          }
          if (data["data"].report.communication[k].name.includes("Crítico")) {
            _.barWidthPercentageComunication2 =
              (data["data"].report.communication[k].score *
                _.defaultMaxBarWidth) /
              100;
            _.barPercentageComunication2 =
              _.barWidthPercentageComunication2 + _.leftDefault;
            _.comunicationStyleSkill2 =
              data["data"].report.communication[k].score;
          }
          if (
            data["data"].report.communication[k].name.includes("Inquisitivo")
          ) {
            _.barWidthPercentageComunication3 =
              (data["data"].report.communication[k].score *
                _.defaultMaxBarWidth) /
              100;
            _.barPercentageComunication3 =
              _.barWidthPercentageComunication3 + _.leftDefault;
            _.comunicationStyleSkill3 =
              data["data"].report.communication[k].score;
          }
          if (data["data"].report.communication[k].name.includes("Consejero")) {
            _.barWidthPercentageComunication4 =
              (data["data"].report.communication[k].score *
                _.defaultMaxBarWidth) /
              100;
            _.barPercentageComunication4 =
              _.barWidthPercentageComunication4 + _.leftDefault;
            _.comunicationStyleSkill4 =
              data["data"].report.communication[k].score;
          }
        }

        // Sort personal skills
        _.personalSortedArray = data["data"].report.auto;
        _.personalSortedArray.sort((a, b) => {
          return a.score < b.score ? 1 : -1;
        });

        //Sort communication skills
        _.communicationSortedArray = data["data"].report.communication;
        _.communicationSortedArray.sort((a, b) => {
          return a.score < b.score ? 1 : -1;
        });
        _.getPercentageBarWidth();
      })
      .catch(() => {});
    _.listenLoadedImgs();
  }

  listenLoadedImgs() {
    const _ = this;
    const trainingLogo = document.querySelector(
      "img.trainingtechnologies"
    ) as HTMLImageElement;
    const companyLogo = document.querySelector(
      ".lacostenalogo"
    ) as HTMLImageElement;
    const mapLogo = document.querySelector("img.mapc") as HTMLImageElement;
    let loadedIntervalReview: any;
    loadedIntervalReview = setInterval(() => {
      clearInterval(loadedIntervalReview);
      if (mapLogo.complete) {
        _.printReport();
      } else {
        _.listenLoadedImgs();
      }
    }, 1000);
  }

  printReport() {
    console.log("Printing report");
    setTimeout(() => {
      this.reportToPDF();
    }, 2000);
  }

  // Methods to generate the new report
  anima_isHidden(e) {
    const _ = this;
    if (!(e instanceof HTMLElement)) return !1;
    if (getComputedStyle(e).display == "none") return !0;
    else if (e.parentNode && _.anima_isHidden(e.parentNode)) return !0;
    return !1;
  }
  anima_loadAsyncSrcForTag(tag) {
    const _ = this;
    var elements = document.getElementsByTagName(tag);
    var toLoad = [];
    for (var i = 0; i < elements.length; i++) {
      var e = elements[i];
      var src = e.getAttribute("src");
      var loaded =
        src != undefined &&
        src.length > 0 &&
        src !=
          "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
      if (loaded) continue;
      var asyncSrc = e.getAttribute("anima-src");
      if (asyncSrc == undefined || asyncSrc.length == 0) continue;
      // if (_.anima_old_onResize(e)) continue;
      toLoad.push(e);
    }
    toLoad.sort(function (a, b) {
      return _.anima_getTop(a) - _.anima_getTop(b);
    });
    for (var i = 0; i < toLoad.length; i++) {
      var e = toLoad[i];
      var asyncSrc = e.getAttribute("anima-src");
      e.setAttribute("src", asyncSrc);
    }
  }
  anima_pauseHiddenVideos() {
    const _ = this;
    var elements = document.getElementsByTagName("video");
    for (var i = 0; i < elements.length; i++) {
      var e = elements[i];
      var isPlaying = !!(
        e.currentTime > 0 &&
        !e.paused &&
        !e.ended &&
        e.readyState > 2
      );
      var isHidden = _.anima_old_onResize(e);
      if (!isPlaying && !isHidden && e.getAttribute("autoplay") == "autoplay") {
        e.play();
      } else if (isPlaying && isHidden) {
        e.pause();
      }
    }
  }

  anima_loadAsyncSrc() {
    const _ = this;
    _.anima_loadAsyncSrcForTag("img");
    _.anima_loadAsyncSrcForTag("iframe");
    _.anima_loadAsyncSrcForTag("video");
    _.anima_pauseHiddenVideos();
  }

  anima_getTop(e) {
    let top = 0;
    do {
      top += e.offsetTop || 0;
      e = e.offsetParent;
    } while (e);
    return top;
  }

  getPercentageBarWidth() {
    const _ = this;
    this.defaultMaxBarWidth = 297;
    _.barWidthPercentage1 = (_.skillSingle1 * _.defaultMaxBarWidth) / 100;
    _.barPercentage1 = _.barWidthPercentage1 + _.leftDefault;
    _.barWidthPercentage2 = (_.skillSingle2 * _.defaultMaxBarWidth) / 100;
    _.barPercentage2 = _.barWidthPercentage2 + _.leftDefault;
    _.barWidthPercentage3 = (_.skillSingle3 * _.defaultMaxBarWidth) / 100;
    _.barPercentage3 = _.barWidthPercentage3 + _.leftDefault;
    _.barWidthPercentage4 = (_.skillSingle4 * _.defaultMaxBarWidth) / 100;
    _.barPercentage4 = _.barWidthPercentage4 + _.leftDefault;
    _.barWidthPercentage5 = (_.skillSingle5 * _.defaultMaxBarWidth) / 100;
    _.barPercentage5 = _.barWidthPercentage5 + _.leftDefault;
    _.barWidthPercentage6 = (_.skillSingle6 * _.defaultMaxBarWidth) / 100;
    _.barPercentage6 = _.barWidthPercentage6 + _.leftDefault;
    _.barWidthPercentage7 = (_.skillSingle7 * _.defaultMaxBarWidth) / 100;
    _.barPercentage7 = _.barWidthPercentage7 + _.leftDefault;
    _.barWidthPercentage8 = (_.skillSingle8 * _.defaultMaxBarWidth) / 100;
    _.barPercentage8 = _.barWidthPercentage8 + _.leftDefault;
    _.barWidthPercentage9 = (_.skillSingle9 * _.defaultMaxBarWidth) / 100;
    _.barPercentage9 = _.barWidthPercentage9 + _.leftDefault;
    _.barWidthPercentage10 = (_.skillSingle10 * _.defaultMaxBarWidth) / 100;
    _.barPercentage10 = _.barWidthPercentage10 + _.leftDefault;
    _.barWidthPercentage11 = (_.skillSingle11 * _.defaultMaxBarWidth) / 100;
    _.barPercentage11 = _.barWidthPercentage11 + _.leftDefault;
    _.barWidthPercentage12 = (_.skillSingle12 * _.defaultMaxBarWidth) / 100;
    _.barPercentage12 = _.barWidthPercentage12 + _.leftDefault;
    _.barWidthPercentage13 = (_.skillSingle13 * _.defaultMaxBarWidth) / 100;
    _.barPercentage13 = _.barWidthPercentage13 + _.leftDefault;
    _.barWidthPercentage14 = (_.skillSingle14 * _.defaultMaxBarWidth) / 100;
    _.barPercentage14 = _.barWidthPercentage14 + _.leftDefault;

    _.barWidthPercentageEffectiveness =
      (_.averageEffectiveness * _.defaultMaxBarWidth) / 100;
    _.barPercentageEffectiveness =
      _.barWidthPercentageEffectiveness + _.leftDefault;
  }
}
